export default __webpack_public_path__ + "static/media/mi5.9213442b.jpg";